import React from "react";
import { FaFacebook } from "react-icons/fa";

const SignInFacebookButton = () => {

  return (
    <div className="facebook-signin-button">
      <div className="icon-button">
        <FaFacebook />
      </div>
      Iniciar Sesión Facebook
    </div>
  );
};

export default SignInFacebookButton;
